import React from 'react'

function About() {
  return (
    <div>
        <h1 className="font-[serif] text-6xl mb-4">Github Finder</h1>
        <div>A website to pull Github user information like name, address, social media, followers, and their repositories</div>
        
    </div>
  )
}

export default About